import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2650d310"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-[calc(100vh-var(--header-container-height,0))] px-4 pt-32 container mx-auto" }
const _hoisted_2 = { class: "relative mx-auto w-[35rem] max-w-full text-center z-10" }
const _hoisted_3 = { class: "text-3xl font-bold mb-4" }
const _hoisted_4 = { class: "text-gray-900" }
const _hoisted_5 = { class: "flex justify-center mt-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_AppTrapezoid = _resolveComponent("AppTrapezoid")!
  const _component_PageNotFoundIcon = _resolveComponent("PageNotFoundIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t('errorPages.notFound.heading')), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('errorPages.notFound.description')), 1),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.canGoBack)
          ? (_openBlock(), _createBlock(_component_AppButton, {
              key: 0,
              size: "large",
              class: "mr-4",
              onClick: _ctx.goBack
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('errorPages.notFound.goBack')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        _createVNode(_component_AppButton, {
          size: "large",
          type: _ctx.canGoBack ? 'secondary' : 'primary',
          onClick: _ctx.goToDashboard
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('errorPages.notFound.backToDashboardPage')), 1)
          ]),
          _: 1
        }, 8, ["type", "onClick"])
      ])
    ]),
    _createVNode(_component_AppTrapezoid, { class: "trapezoid hidden !left-0 !right-auto !h-full !w-1/6 bg-gray-300 z-0 md:block before:!w-full before:!left-1/6 before:!-skew-x-6 before:!origin-bottom-left" }),
    _createVNode(_component_PageNotFoundIcon, { class: "not-found-icon absolute bottom-12 left-1/2 w-[353px] h-[291px] max-w-[100%] transform -translate-x-2/4 z-0 md:left-[8%] md:translate-x-0 xl:left-[12%]" })
  ]))
}